<template>
    <set-google-json-credentials-dialog
        :value="value"
        @input="$emit('input', $event)"
        :loading="$wait.is('creatingGoogleAccount')"
    >
        <template #activator="bindings">
            <slot name="activator" v-bind="bindings"></slot>
        </template>
        <template #actions="{ form, formId, isValid, clear, close }">
            <post-cloud-account-button
                :value="{ ...form, Type: 'Google' }"
                :clear="clear"
                :valid="isValid"
                :form="formId"
                v-wait-while="'creatingGoogleAccount'"
                @http2xx="close().then(() => $emit('http2xx', $event))"
            ></post-cloud-account-button>
        </template>
    </set-google-json-credentials-dialog>
</template>

<script>
import SetGoogleJsonCredentialsDialog from '@/components/Settings.CloudAccounts/Google/SetGoogleJsonCredentialsDialog.vue';
import PostCloudAccountButton from '@/components/Settings.CloudAccounts/PostCloudAccountButton';
export default {
    components: { SetGoogleJsonCredentialsDialog, PostCloudAccountButton },
    props: {
        value: Boolean,
    },
};
</script>